<template>
	<div class="inside-page">
		<van-nav-bar :title="$t('关于我们')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="layui-container">
			<div class="article-content">
				<div style="margin-bottom: 20px;">
					<img :src="data.thumb" alt="" />
				</div>
				<h1 class="about-title">{{data.title}}</h1>
				<div v-html="data.content"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		index_notice_list_api,
		index_notice_details_api
	} from '@/api/index'
	export default {
		data() {
			return {
				data: {},
				pageid: 0
			};
		},
		methods: {
			async getDetailNotice(pageid) {
				let param = {
					id: pageid,
				};
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				const res = await index_notice_details_api(param);
				if (res && res.data.code == 1) {
					this.data = res.data.data
					loading.close()
				}else{
					loading.close()
				}
				
			},
			async getNotice() {
				let param = {};
				const res = await index_notice_list_api(param);
				if (res && res.data.code == 1) {
					this.pageid = res.data.data.filter(item => item.is_nav === 1)[0].id;
					this.getDetailNotice(this.pageid)
				}
			}
		},
		mounted() {
			this.getNotice()
		}
	}
</script>
<style scoped>
	.about-title {
		margin-bottom: 20px;
		text-align: center;
	}
</style>